import { Injectable } from '@angular/core';

/**
 * Asset Type Mapper Service
 * Provides utility functions for mapping asset types between display format and API format
 */
@Injectable({
  providedIn: 'root',
})
export class AssetTypeMapperService {
  /**
   * Map display asset type to API format
   * @param displayType Display name (e.g., "Dataset", "Model", "App", "Use Case")
   * @returns API format (e.g., "adex:DataBank", "adex:AiModel", "adex:Apps", "adex:UseCase")
   */
  mapAssetTypeToApiFormat(displayType: string): string {
    const typeMap: Record<string, string> = {
      Dataset: 'adex:DataBank',
      Model: 'adex:AiModel',
      App: 'adex:Apps',
      UseCase: 'adex:Apps',
      'Use Case': 'adex:Apps',
      Usecase: 'adex:Apps',
    };
    return typeMap[displayType] || displayType;
  }

  /**
   * Map API asset type to display format
   * @param apiType API format (e.g., "adex:DataBank", "adex:AiModel", "adex:Apps", "adex:UseCase")
   * @returns Display name (e.g., "Dataset", "Model", "App", "Use Case")
   */
  mapApiFormatToAssetType(apiType: string): string {
    const normalized = String(apiType ?? '').trim();
    const reverseMap: Record<string, string> = {
      'adex:DataBank': 'Dataset',
      'adex:AiModel': 'Model',
      'adex:aiModel': 'Model',
      'adex:Apps': 'App',
      'adex:UseCase': 'Use Case',
    };
    if (reverseMap[normalized]) {
      return reverseMap[normalized];
    }
    const lower = normalized.toLowerCase();
    const byLower: Record<string, string> = {
      'adex:databank': 'Dataset',
      'adex:aimodel': 'Model',
      'adex:apps': 'App',
      'adex:usecase': 'Use Case',
    };
    return byLower[lower] || apiType;
  }
}

